<template>

    <teleport to="#modal">

    </teleport>

    <div class="m-auto px-8 md:px-20 pb-8 pt-3">

        <Alert v-if="error_message" :dismissable="true" @close="error_message = ''"
               class="bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50">
            {{ error_message }}
        </Alert>

        <div class="py-10 flex justify-between">
            <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
        </div>

        <div v-show="!StessaValutaVendita" class="bg-next-orange text-white p-3 mb-3 font-bold">
            I record non sono nella medesima valuta di vendita. Impossibile creare l'ordine di vendita.
        </div>
        <div class="pb-5 flex justify-between items-center">
            <h1 class="text-2xl">
                Sottoprogetto: <span class="font-bold">{{ sottoprogetto?.titolo }}</span> - Cliente: <span
                class="font-bold">{{ cliente.denominazione }}</span>
            </h1>
            <div class="flex items-center">
                <h1 class="text-2xl mr-1">
                    Destinatario:
                </h1>
                <div class="flex flex-col lg:col-span-2 w-96">
                    <Field :label-visible="false" :required="!destinatarioAutocomplete?.selection"
                           placeholder="Cliente">
                        <VueMultiselect @search-change="destinatarioAutocomplete.search"
                                        :loading="destinatarioAutocomplete.isLoading"
                                        :options="destinatarioAutocomplete.options"
                                        v-model="destinatarioAutocomplete.selection"
                                        track-by="id" label="denominazione"
                                        class="next-vue-multiselect-single"
                                        placeholder="Cliente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                            </template>
                            <template v-slot:option="{option}">{{
                                    `${option.denominazione} - ${option.ragione_sociale}`
                                }}
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
            </div>
        </div>

        <div class="m-auto">
            <div class="grid grid-cols-12 gap-3 mb-5">
                <CardDivisorioGrigio class="col-span-2">
                    <template v-slot:top>
                        <div class="text-sm"><b>Totale costi</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{
                                Totalizzatori.totale_costi?.toCurrencyString()
                            }} €
                        </div>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio class="col-span-2">
                    <template v-slot:top>
                        <div class="text-sm"><b>Totale ordinato</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{
                                Totalizzatori.totale_ordinato?.toCurrencyString()
                            }} €
                        </div>
                    </template>
                </CardDivisorioGrigio>
                <div class="col-span-2 col-start-11 flex justify-end items-start">
                    <NextButton class="px-10 py-3" @click="creaODV">Crea ODV</NextButton>
                </div>
            </div>

            <div class="overflow-x-scroll">
                <template v-for="(i,k) in records" :key="k">
                    <div class="border-b-next-atp border-b-2 text-next-atp mb-3 sticky left-0">
                        <p class="font-bold">Aliquota: <span>{{
                                k in AliquoteVendita ? AliquoteVendita[k]?.descrizione : 'Sconosciuta'
                            }}</span></p>
                    </div>
                    <div class="flex gap-3 mb-3 sticky left-0">
                        <!--                        <p>Totale costi: <span>{{-->
                        <!--                                k in TotalizzatoriIva ? TotalizzatoriIva[k]?.totale_costi?.toCurrencyString() : 'Sconosciuta'-->
                        <!--                            }} €</span></p>-->
                        <p>Totale ordinato: <span>{{
                                k in TotalizzatoriIva ? TotalizzatoriIva[k]?.totale_ordinato?.toCurrencyString() : 'Sconosciuta'
                            }} €</span></p>
                        <p>Totale ricavi:
                            <span>{{
                                    k in TotalizzatoriIva ? TotalizzatoriIva[k]?.totale_ricavi?.toCurrencyString() : 'Sconosciuta'
                                }} €</span>
                        </p>
                    </div>
                    <div class="rotate-x-180 overflow-x-scroll mb-5 pb-3">
                        <OffertaTable
                            class="rotate-0 overflow-hidden mb-3"
                            actionClass="relative"
                            :ordered_records="i"
                            @order-update="performOrder"
                        >

                        </OffertaTable>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue,} from 'vue-class-component';
import {mapActions, mapGetters, mapState} from 'vuex';
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import sottoProgettiManager from "../api/SottoProgetti";
import TableTooltip from "@/components/TableTooltip.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import CardDivisorioGrigio from "@/components/CardDivisorioGrigio.vue";
import DynamicCell from "@/components/DynamicCell.vue";
import NextSottoProgettoTable from "@/components/NextSottoProgettoTable.vue";
import OffertaTable from '@/components/OffertaTable.vue';
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import Checkbox from "@/components/Checkbox.vue";
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";
import Alert from "@/components/Alert.vue";
import progettiManager from "../api/Progetti";
import NextTable from "@/components/NextTable.vue";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import InfiniteLoading from "v3-infinite-loading";
import ModalOdv from "@/components/ModalPianoFatturazione.vue";
import ModalRigaPagamento from "@/components/ModalRigaPagamento.vue";
import Autocomplete from "@/setup/Autocomplete";
import clientiManager from "../api/Clienti";
import Field from "@/components/Field.vue";

@Options({
    name: 'SottoProgettoODV',
    components: {
        Field,
        ModalOdv,
        ConfirmDelete,
        InfiniteLoading,
        ModalRigaPagamento,
        TabellaContextMenu,
        NextTable,
        Alert,
        Modal,
        NextButton,
        Checkbox,
        Breadcrumbs,
        OffertaTable,
        NextSottoProgettoTable,
        DynamicCell,
        CardDivisorioGrigio,
        MultiselectOption, TableTooltip,
    },
    props: {
        id: String,
        idf: String,
    },
    computed: {
        ...mapState('buFieldModule', {
            sottoProgettiCols: (state: any) => state.sottoProgettiCols
        }),
        ...mapGetters('buFieldModule', [
            'OrderedRows',
        ]),
        ...mapGetters('sprjDataManager', [
            "ActiveTab",
            "AliquoteVendita",
            "RecordSfusi",
            "SelectedRows",
            "RecordPerIvaVendita",
            "TotalizzatoriIva",
            "Sottoprogetto",
            "ValutaAcquisto",
            "StessaValutaVendita",
            'TotaleCostiEuroProgetto',
            'TotaleUtiliProgetto',
            'TotaleRicaviProgetto',
            'TotaleMol',
            'AcCostoUnitarioNetto',
            'AcCostoTotale',
            'VeBudget',
            'BudgetLordoIva',
            'Utile',
            'CostoVenditaUnitario',
            'Mol',
        ])
    },
    methods: {
        ...mapActions('buFieldModule', [
            'fetchSottoprogettoUserPreference',
            'setAcquistoHidden',
            'setAllVisible',
            'orderChange',
        ]),
        ...mapActions('sprjDataManager', [
            'setSottoprogetto',
            'setDatiSottoprogetto',
            "setFornitoreId",
            "prepareDataForODA",
            "retrieveData",
            'setValute',
        ]),
    },
})
export default class SottoProgettoODV extends Vue {
    destinatarioAutocomplete: any = setup(() => Autocomplete(clientiManager))

    RecordSfusi!: any
    StessaValutaVendita!: any
    RecordPerIvaVendita!: any
    TotalizzatoriIva!: any
    AliquoteVendita!: any
    Sottoprogetto!: any

    setValute!: any
    TotaleCostiProgetto!: any
    TotaleRicaviProgetto!: any
    TotaleUtiliProgetto!: any
    setAcquistoHidden!: any
    setSottoprogetto!: any
    setDatiSottoprogetto!: any

    id!: number | string
    loading = false
    error_message = ''

    sottoprogetto: any = {}
    progetto: any = {}
    cliente: any = {}

    records = []

    performOrder(cols: string) {
        //@ts-ignore
        this.orderChange(cols).then(() => {
            this.updateSectionData()
        })
    }

    updateSectionData() {
        const b = this.RecordSfusi
    }

    @Watch('destinatarioAutocomplete.selection')
    destinatario(new_value: any, old: any) {
        this.sottoprogetto.destinatario_odv_id = new_value?.id || new_value
        sottoProgettiManager.setDestinatario(this.id, {destinatario_odv_id: this.sottoprogetto.destinatario_odv_id})
    }

    async created() {
        this.destinatarioAutocomplete.addAjaxParam('gamma', 1)
        sottoProgettiManager.sottoprogetto(this.id).then(async (res: any) => {
            await this.setSottoprogetto(res.data)
            return this.setDatiSottoprogetto(JSON.parse(res.data.ultimi_dati))
        }).then(() => {
            this.sottoprogetto = this.Sottoprogetto
            this.destinatarioAutocomplete.retrieve(this.sottoprogetto.destinatario_odv_id)
            this.records = this.RecordPerIvaVendita
            return this.setValute(this.sottoprogetto?.ultimi_dati.valute)
        }).then(() => {
            return progettiManager.progetto(this.sottoprogetto.progetto_id)
        }).then((res) => {
            this.progetto = res.data
            return clientiManager.retrieve(this.progetto.cliente_id)
        }).then((res) => {
            this.cliente = res.data
        })

        this.setAcquistoHidden()

    }

    get Totalizzatori() {
        const sf = this.RecordSfusi
        return {
            totale_costi: this.TotaleCostiProgetto([{records: sf}]),
            totale_ordinato: this.TotaleRicaviProgetto([{records: sf}]),
            totale_ricavi: this.TotaleUtiliProgetto([{records: sf}]),
        }
    }

    get getBreadcrumbsPath() {
        return [
            {
                title: 'Progetto',
                name: 'DettaglioProgetto',
                params: {id: this.sottoprogetto.progetto_id || 0}
            },
            {
                title: 'Sottoprogetto',
                name: 'DettaglioSottoProgetto',
                params: {id: this.id || 0}
            },
            {
                title: 'ODV',
            }
        ]
    }

    prepareData() {
        return this.TotalizzatoriIva
    }

    creaODV() {
        const data = this.prepareData()
        // sottoProgettiManager.creaOdv(this.id, thisprepareData)
    }

}

</script>


<style lang="scss">

</style>
